import { Component, ElementRef, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  Validators,
  UntypedFormGroup,
  UntypedFormArray,
  AbstractControl,
  ValidatorFn,
  ValidationErrors,
} from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { ViewChild } from "@angular/core";
import { Clients } from "../../../models/clients";
import { Category } from "../../../models/category";
import { UntypedFormControl } from "@angular/forms";
import { CategoryService } from "../../../services/categories.service";
import { ConfirmationService, MessageService, SelectItem } from "primeng/api";
import {
  FISCAL_CODE_VALIDATOR_REGEX,
  STATE_LIST,
  STATE_PUBLISHED,
  BLOG_LIST,
  LEVEL_PUBLISHED,
} from "../../constants/constants";
import { Comuni } from "src/app/models/comuni";
import { Location } from "@angular/common";
import { AppointmentsService } from "src/app/services/appointments.service";
import { Appointments } from "src/app/models/appointments";
import { BillingsService } from "src/app/services/billings.service";
import { Billings } from "src/app/models/billings";
import { Personal_data } from "src/app/models/personal_data";
import { NgxSpinnerService } from "ngx-spinner";
import { NewsService } from "src/app/services/news.service";
import { Slideshow } from "src/app/models/slideshow";
import { News } from "src/app/models/news";
import { Tags } from "src/app/models/tags";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { EditorModule } from "primeng/editor";
import { SelectModule } from "primeng/select";
import { InputTextModule } from "primeng/inputtext";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { TabsModule } from "primeng/tabs";
import { ToastModule } from "primeng/toast";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { TextareaModule } from "primeng/textarea";
import { ImageModule } from "primeng/image";
import { SlugTransformDirective } from "../../pipe/slug-transform.directive";
import { UploadNewsComponent } from "../../components/upload-news/upload-news.component";
import { UploadComponent } from "../../components/upload/upload.component";
import { TooltipModule } from "primeng/tooltip";
import { InputGroupModule } from "primeng/inputgroup";
import { InputGroupAddonModule } from "primeng/inputgroupaddon";

import { TopNavComponent } from "src/app/top-nav/top-nav.component";

import { MultiSelectModule } from "primeng/multiselect";

import { DatePickerModule } from "primeng/datepicker";

import { SelectButtonModule } from "primeng/selectbutton";

@Component({
  standalone: true,
  selector: "app-news-form",
  templateUrl: "./news-form.component.html",
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    EditorModule,
    SelectModule,
    InputTextModule,
    ButtonModule,
    CardModule,
    TabsModule,
    ToastModule,
    ConfirmDialogModule,
    TextareaModule,
    ImageModule,
    SlugTransformDirective,
    UploadNewsComponent,
    UploadComponent,
    TooltipModule,
    InputGroupModule,
    InputGroupAddonModule,
    TopNavComponent,
    MultiSelectModule,
    DatePickerModule,
    SelectButtonModule,
  ],
})
export class NewsFormComponent implements OnInit {
  @ViewChild("myInput", { static: false }) myInputVariable: ElementRef;

  pageTitle: string;
  error: string;
  uploadError: string;
  imagePath: any;
  imagePathFirst: any;
  imagePathSecond: any;

  blogForm: UntypedFormGroup;

  selectedTours: SelectItem[] = [];
  selectedItemDisplay: string;

  selectedDate: Date;
  date: Date;
  deleteButton: boolean;
  currentUser: any;
  element: News;
  stateOptions: any[] = STATE_LIST;
  blogOptions: any[] = BLOG_LIST;

  selectedStatePublished: SelectItem[] = [];
  selectedLevelPublished: SelectItem[] = [];
  categoriesList: Category[] = [];
  selectedCategories: SelectItem[] = [];
  statePublished: any[] = STATE_PUBLISHED;
  levelPublished: any[] = LEVEL_PUBLISHED;
  trackByFn(index, item) {
    return item.id;
  }

  constructor(
    private fb: UntypedFormBuilder,
    private messageService: MessageService,
    private newsService: NewsService,
    private categoryService: CategoryService,
    private _location: Location,
    private appointmentsService: AppointmentsService,
    private billingsService: BillingsService,
    private spinner: NgxSpinnerService,
    private confirmationService: ConfirmationService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    if (this.date) {
      this.selectedDate = new Date(this.date);
    }
    this.currentUser = JSON.parse(localStorage.getItem("currentUser") || "[]");
    const userId = this.currentUser.user_id;
  }

  ngOnInit() {
    this.spinner.show();
    this.blogForm = this.fb.group({
      id: [""],
      page_title: ["", Validators.required],
      description_1: [""],
      description_2: [""],
      description_3: [""],
      page_seotitle: [""],
      page_seokeywords: [""],
      page_seodescription: [""],
      page_url: [""],
      level: [""],
      date_created: ["", [dateValidator()]],
      tags: [""],
      status: [""],
      is_active: ["0"],
      is_featured: ["0"],
    });

    this.getCategories();

    const id = this.route.snapshot.paramMap.get("id");
    if (id) {
      this.pageTitle = "Modifica News";

      this.newsService.getId(+id).subscribe((res) => {
        this.element = res;

        this.blogForm.patchValue({
          page_title: res.page_title,
          description_1: res.description_1,
          description_2: res.description_2,
          description_3: res.description_3,
          page_seotitle: res.page_seotitle,
          page_seokeywords: res.page_seokeywords,
          page_seodescription: res.page_seodescription,
          page_url: res.page_url,
          status: res.status,
          date_created: res.date_created ? res.date_created.substring(0, 10) : "",
          tags: (res.tags || "").split(",").map(Number).filter(Boolean),
          level: res.level,
          is_active: res.is_active,
          is_featured: res.is_featured,
          id: res.id,
        });

        this.imagePath = res.image;
      });
    } else {
      this.deleteButton = false;
      this.pageTitle = "Aggiungi News";
    }

    this.spinner.hide();
  }

  get f(): { [key: string]: AbstractControl } {
    return this.blogForm.controls;
  }

  public getCategories() {
    const paramsCategories = [];
    this.categoryService.list(paramsCategories).subscribe((pData) => {
      this.categoriesList = pData;
    });
  }

  onSelectedFile(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.blogForm.get("image").setValue(file);

      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (_event) => {
        this.imagePath = reader.result;
      };
    }
  }

  removeImageFile() {
    this.imagePath = "";
    console.log(this.myInputVariable.nativeElement.files);
    this.myInputVariable.nativeElement.value = "";
    console.log(this.myInputVariable.nativeElement.files);
  }

  onDelete(id: number, title: string) {
    this.confirmationService.confirm({
      message: "Sei sicuro di volerlo cancellare",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.newsService.delete(+id).subscribe(
          (res) => {
            console.log(res);
            this.messageService.add({
              key: "cancel",
              severity: "success",
              summary: "Attenzione",
              detail: "Cancellazione avvenuto con successo",
            });
            this._location.back();
          },
          (error) => {
            this.error = error;
            this.messageService.add({
              key: "cancel",
              severity: "warn",
              summary: "Attenzione",
              detail: "Errore backend",
            });
          },
        );
      },
    });
  }

  get title() {
    return this.blogForm.get("title");
  }

  get id() {
    return this.blogForm.get("id").value;
  }

  get description() {
    return this.blogForm.get("description");
  }

  get dateCreated() {
    return this.blogForm.get("date_created");
  }

  selectDivision(e) {
    this.selectedTours = e.value.map((item) => item.name);
    if (this.selectedTours.length > 3) {
      this.selectedItemDisplay = `Selected items: ${this.selectedTours.join(", ")}`;
    } else {
      this.selectedItemDisplay = "";
    }
  }

  onSubmit() {
    const formData = new FormData();
    formData.append("page_title", this.blogForm.get("page_title").value);
    formData.append("page_url", this.blogForm.get("page_url").value);
    formData.append("status", this.blogForm.get("status").value);
    formData.append("is_active", this.blogForm.get("is_active").value);
    formData.append("level", this.blogForm.get("level").value);
    formData.append("tags", this.blogForm.get("tags").value);
    formData.append("description_1", this.blogForm.get("description_1").value);
    formData.append("description_2", this.blogForm.get("description_2").value);
    formData.append("description_3", this.blogForm.get("description_3").value);
    formData.append("page_seotitle", this.blogForm.get("page_seotitle").value);
    formData.append(
      "page_seokeywords",
      this.blogForm.get("page_seokeywords").value,
    );
    formData.append(
      "page_seodescription",
      this.blogForm.get("page_seodescription").value,
    );
    formData.append("is_featured", this.blogForm.get("is_featured").value);
    formData.append("date_created", this.blogForm.get("date_created").value);

    const id = this.blogForm.get("id").value;

    if (id) {
      this.newsService.update(formData, +id).subscribe(
        (res) => {
          if (res.status == "error") {
            this.uploadError = res.message;
            this.messageService.add({
              key: "myKey1",
              severity: "warn",
              summary: "Attenzione",
              detail: "Salvato senza sucesso",
            });
          } else {
            this.messageService.add({
              key: "myKey1",
              severity: "success",
              summary: "Attenzione",
              detail: "Salvato con sucesso",
            });
            // this._location.back();
          }
        },
        (error) => (this.error = error),
      );
    } else {
      this.newsService.create(formData).subscribe(
        (res) => {
          if (res.status === "error") {
            this.uploadError = res.message;
          } else {
            this.messageService.add({
              key: "myKey1",
              severity: "success",
              summary: "Attenzione",
              detail: "Salvato con sucesso",
            });
            this.router.navigate(["/admin/news"]);
          }
        },
        (error) => (this.error = error),
      );
    }
  }
}

export function codFisc(c: UntypedFormControl): { [s: string]: boolean } {
  if (c.value && !c.value.match(FISCAL_CODE_VALIDATOR_REGEX)) {
    return { invalidCF: true };
  }
}

export function dateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;
    const datePattern = /^\d{4}-\d{2}-\d{2}$/;
    return datePattern.test(control.value) ? null : { invalidDateTime: true };
  };
}
